export default __webpack_public_path__ + "static/media/laser-icon.54b90a9f.svg";